import React from 'react';
import { Box } from '@mui/material';

interface LogoSpinnerProps {
  size?: number;
  minHeight?: string | number;
  fullScreen?: boolean;
}

const LogoSpinner: React.FC<LogoSpinnerProps> = ({ 
  size = 40, 
  minHeight = '200px',
  fullScreen = false 
}) => {
  const containerStyles = fullScreen 
    ? {
        position: 'fixed' as const,
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#ffffff',
        zIndex: 9999
      }
    : {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: minHeight
      };

  return (
    <Box sx={containerStyles}>
      <img
        src="/logo_inttech.png"
        alt="Loading..."
        style={{
          width: `${size}px`,
          height: `${size}px`,
          objectFit: 'contain',
          animation: 'logoSpin 2s linear infinite',
        }}
      />
      <style>
        {`
          @keyframes logoSpin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </Box>
  );
};

export default LogoSpinner; 